// © 2025 Emmanuel Takyi Obodai — All rights reserved
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import "font-awesome/css/font-awesome.min.css";

console.log("%c Built by Emmanuel Takyi Obodai © 2025", "color: #c9a84c; font-weight: bold; font-size: 14px;");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
